import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import apis from './apis';
import { message, Form, Select, TreeSelect, Empty, Tabs, Spin } from 'antd';
import { Button, Icon, Label } from '@jd/jmtd';
import ProviderUserTypeInfo from './provider-userType-info';
import { filterConditions } from '@/common/utils';
import ActivityDetail from './components/activity-detail';
import ActivityTab from './components/activity-tab';
import IconTip from '@/components/icon-tip';
import './index.less';
import GlobalEffect from './components/global-effect';
import SecKill from './components/secKill-tab';
import Search from './components/search';
import MicroApp from '@/common/jmtd-micro-app';
import SalesTab from './components/sales-tab';
import GoodsTab from './components/goods-tab';
import CommonNoAccess from './components/no-access'
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';

const userTypeObj = {
  'placeErp': {
    "ord": "4",
    "value": "销售ERP",
    "key": "placeErp"
  },
  'dept':   {
    "ord": "1",
    "value": "运营部门",
    "key": "dept"
  },
  'erp': {
    "ord": "2",
    "value": "运营ERP",
    "key": "erp"
  },
  'placeDept': {
    "ord": "3",
    "value": "销售部门",
    "key": "placeDept"
  }
}
const userType = ['placeErp', 'placeDept', 'dept', 'erp']
function formatUserType(type){
  const typeList = type.map(item=>(item.key))
  const newTypeList = _.intersection(userType,typeList);
  return newTypeList.map(item=>(userTypeObj[item]))
}
function findFirstAvailableCode(arr) {
  if (!arr || !arr.length) return [];
  let fullCode = '';
  function findCode(list) {
    let code = '';
    code = list.find((item) => !item.disabled);
    if (!code && list[0].children && list[0].children.length) {
      findCode(list[0].children);
    } else {
      fullCode = code.deptFullCode;
    }
  }
  findCode(arr);
  return fullCode;
}

const _ParticipantData = forwardRef((props, ref) => {
  const mvpRef = useRef(null);
  const [form] = Form.useForm();
  const [dataScopeFilter, setDataScopeFilter] = useState();
  const [filter, setFilter] = useState();
  const [originFilter, setOriginFilter] = useState();
  const [position, setPosition] = useState('1');
  const [loaded, setLoaded] = useState(false);
  const [noAccess, setNoAccess] = useState(false);
  const [reload, setReload] = useState(-1);
  const [userType, setUserType] = useState('');

  const [activeKey, setActiveKey] = useState('搜索');

  // 关键代码
  useImperativeHandle(ref, () => ({
    reLoad: () => {
      console.log('触发刷新------')
      setReload(Math.random)
    },
  }));

  const _ref = React.useRef();
  useEffect(() => {
    _ref.current && _ref.current.show();
  }, []);

  //活动详情需要的参数
  const [activityDetailParams, setActivityDetailParams] = useState('');
  const [subFilter, setSubFilter] = useState(null);

  const formDisabled = useRef(null);
  formDisabled.current = !!activityDetailParams.planCode;

  const changeActivityDetailParams = (params, subFilter) => {
    document.documentElement.scrollTop = 0;
    if (!params) {
      setActivityDetailParams('');
      setSubFilter(null)
      return;
    }
    const { planCode, planName, activityStartTime, activityEndTime, activityStatus, planPercent } = params;
    setActivityDetailParams({ planCode, planName, activityStartTime, activityEndTime, activityStatus, planPercent });
    setSubFilter(subFilter)
  };

  function getFilterValue(value) {
    let formValues = {};
    if (value.userType == 'dept' || value.userType == 'placeDept') {
      const { dept } = value;
      const _dept = dept.split('/');
      let buId = _dept[0],
        deptId1 = _dept[1] || '全部',
        deptId2 = _dept[2] || '全部',
        deptId3 = _dept[3] || '全部',
        deptId4 = _dept[4] || '全部',
        participant = '全部';
      formValues = { userType: value.userType, buId, deptId1, deptId2, deptId3, deptId4, participant };
    }
    if (value.userType == 'erp' || value.userType == 'placeErp') {
      formValues = { userType: value.userType, participant: value.erp };
    }
    return filterConditions(formValues);
  }

  function onChangeOriginFilter(val){
    // console.log('onChangeOriginFilter-----------', val)
    const { userType } = filter;
    const value = {
      userType: userType,
      dept:val.dept,
      erp: val.erp,
    };
    form.setFieldsValue(value);
    setOriginFilter(value)
    setFilter(getFilterValue(value));
    setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
  }

  useEffect(() => {
    apis
      .queryGeneralDataScopeByErp()
      .then((res) => {
        setLoaded(true);
        const { ret, data } = res;
        if (ret === '0' && data && data.userType) {
          if(data.userType?.length > 0){
            // 下线销售部门
            data.userType = data.userType.filter((item)=>(item.key != 'placeDept'))
            data.userType = formatUserType(data.userType)
            setNoAccess(false)
          } else{
            setNoAccess(true)
          }
          setDataScopeFilter(data);
        } else {
          throw '暂无数据';
        }
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, []);

  //初始值;
  useEffect(() => {
    if (!dataScopeFilter?.userType?.length) return;
    const { userType, dataScope } = dataScopeFilter;
    const _userType = userType[0]?.key;
    const value = {
      userType: _userType,
      dept:
        (_userType == 'dept' || _userType == 'placeDept') && dataScope[_userType]
          ? findFirstAvailableCode(dataScope[_userType])
          : [],
      erp: (_userType == 'placeErp' || _userType == 'erp') && dataScope[_userType] ? dataScope[_userType][0] : [],
    };

    form.setFieldsValue(value);
    setOriginFilter(value)
    setFilter(getFilterValue(value));
    setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
  }, [dataScopeFilter, form]);

  const onFormChange = (changeValue, allValue) => {

    if (changeValue.userType) {
      const _userType = changeValue.userType;
      const { dataScope } = dataScopeFilter;
      const value = {
        userType: _userType,
      };
      if ((_userType == 'dept' || _userType == 'placeDept') && dataScope[_userType]) {
        value.dept = findFirstAvailableCode(dataScope[_userType]);
      } else if ((_userType == 'placeErp' || _userType == 'erp') && dataScope[_userType]) {
        value.erp = dataScope[_userType][0];
      }
      form.setFieldsValue(value);
      setOriginFilter(value)
      setFilter(getFilterValue(value));
      setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
    } else {
      const value = form.getFieldsValue(true);
      setOriginFilter(value)
      setFilter(getFilterValue(value));
      setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
    }
  };

  function EmptyBlock() {
    return (
      <Empty
        className="participant-data-empty-block"
        description="销售部门下细分场域数据底层未进行改造，请筛选运营部门/运营ERP后查看数据"
      />
    );
  }
  function NoAccess() {
    return (
      <CommonNoAccess/>
      // <Empty
      //   style={{ paddingTop: 250 }}
      //   description="您当前暂无部门看数权限，请搜索并进入咚咚群咨询权限开通流程:10202084337"
      // />
    );
  }

  const handleLog = (val) =>{
    window.log('yx_center_hzcp_1680082497624', val)
  }

  const onChangeSubTabs = (key) => {
    switch (key){
      case '搜索':
        handleLog(9)
        break;
      case '推荐':
        handleLog(10)
        break;
      case '频道':
        handleLog(11)
        break;
      case '活动':
        handleLog(12)
        break;
    }
    setActiveKey(key);
  };

  const onChangeTabs = (key) => {
    setPosition(key);
  };



  if (!loaded) return <Spin spinning={!loaded} style={{ width: '100%', marginTop: '15%' }} />;

  return  (
    <div ref={mvpRef} style={{ background: '#F2F3F5', padding: '16px 0', height: '100%', minHeight: '100vh', minWidth: '1200px' }}>
      <div className="participant-title-con" id="participant-title-con">
        <div className="participant-data-con">
          <Label className={`participant-data-main-title ${position === '1' ? 'sel' : ''}`} ><span onClick={()=>{setPosition('1');handleLog(7)}}>日销监控</span></Label>
          {/*<Label className={`participant-data-main-title ${position === '2' ? 'sel' : ''}`} ><span onClick={()=>{setPosition('2');handleLog(8)}}>场域效果</span></Label>*/}
        </div>
        <Button
          className='new-guide-btn'
          startIcon={<Icon className='jmti-question-circle' />}
          link
          semantic='primary'
          onClick={props.showNewerGuide}
        >
          新手帮助
        </Button>
      </div>

      <Tabs className="field-tabs" type="card" onChange={onChangeTabs}
            activeKey={position}>
        <Tabs.TabPane tab="日销监控" key="1">
          {
            !dataScopeFilter?.userType?.length ?
              <NoAccess /> :
              <React.Fragment>
                <div className="participant-data-card-bg-new">
                  <div className="participant-data-con">
                    <Form form={form} layout="inline" onValuesChange={onFormChange}>
                      <Form.Item
                        name="userType"
                        label={
                          <span>
                数据范围
                <IconTip title="选择您有权限的角色及数据范围。运营部门/ERP同黄金眼一致，销售ERP代表采销控分离后的销售人员。如有疑问请进咚咚群咨询:10204982304" />
              </span>
                        }
                        initialValue={dataScopeFilter.userType[0].key}
                      >
                        <Select style={{ width: 200 }}>
                          {dataScopeFilter?.userType?.map((item) => (
                            <Select.Option value={item.key} key={item.key}>
                              {item.value}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item noStyle shouldUpdate={(prevValue, curValue) => prevValue.userType !== curValue.level}>
                        {({ getFieldValue }) => {
                          const userType = getFieldValue('userType');
                          if (userType == 'dept' || userType == 'placeDept') {
                            return (
                              <Form.Item
                                name="dept"
                              >
                                <TreeSelect
                                  // disabled={formDisabled.current}
                                  style={{ width: 300 }}
                                  changeOnSelect
                                  allowClear={false}
                                  fieldNames={{ label: 'name', value: 'deptFullCode', children: 'children' }}
                                  treeData={dataScopeFilter.dataScope[userType]}
                                  treeNodeLabelProp="deptFullName"
                                />
                              </Form.Item>
                            );
                          }
                          if (userType == 'placeErp' || userType == 'erp') {
                            return (
                              <Form.Item
                                name="erp"
                              >
                                <Select
                                  // disabled={formDisabled.current}
                                  style={{ width: 200 }}
                                  showSearch
                                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                >
                                  {dataScopeFilter.dataScope[userType]?.map((item) => (
                                    <Select.Option value={item} key={item}>
                                      {item}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            );
                          }
                        }}
                      </Form.Item>
                    </Form>
                  </div>
                </div>
                {
                  filter?.userType === 'placeErp' ?
                    <React.Fragment>
                      <SalesTab filter={filter} erp={props.erp} toSalePlan={props.toSalePlan} reload={reload}></SalesTab>
                      {/*<GoodsTab filter={filter} erp={props.erp} dataScopeFilter={dataScopeFilter} originFilter={originFilter} onChangeOriginFilter={onChangeOriginFilter} toProductGroup={props.toProductGroup}></GoodsTab>*/}
                    </React.Fragment> :
                    <React.Fragment>
                      <GlobalEffect filter={filter} erp={props.erp}/>
                      {/*<SkuAnalysis filter={filter} dataScopeFilter={dataScopeFilter} originFilter={originFilter} onChangeOriginFilter={onChangeOriginFilter}/>*/}
                    </React.Fragment>
                }
                <GoodsTab filter={filter} erp={props.erp} dataScopeFilter={dataScopeFilter} originFilter={originFilter} onChangeOriginFilter={onChangeOriginFilter} toProductGroup={props.toProductGroup}></GoodsTab>
              </React.Fragment>
          }

        </Tabs.TabPane>
        <Tabs.TabPane tab="场域效果" key="2">
          <div className="field-subdivision">
            <Tabs className="field-subdivision-tabs" type="card" onChange={onChangeSubTabs}
                  activeKey={activeKey}>
              <Tabs.TabPane tab="搜索" key="搜索">
                <Search />
              </Tabs.TabPane>
              <Tabs.TabPane tab="推荐" key="推荐">
                <div style={{ background: '#f2f3f5' }}>
                  <MicroApp
                    src="//storage.360buyimg.com/sz-page-service/build/869-1-55.0.0.js"
                    pre
                    pageId="869"
                  ></MicroApp>
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="频道" key="频道">
                <SecKill/>
              </Tabs.TabPane>
              <Tabs.TabPane tab="活动" key="活动">

                {!formDisabled.current && (
                  <ProviderUserTypeInfo.Provider>
                    <ActivityTab gotoDetail={changeActivityDetailParams} />
                    {/*<ActivityParticipationEffect gotoDetail={changeActivityDetailParams} />*/}
                  </ProviderUserTypeInfo.Provider>
                )}
                {formDisabled.current && (
                  <ProviderUserTypeInfo.Provider value={subFilter}>
                    <ActivityDetail {...activityDetailParams} gotoAllActivity={changeActivityDetailParams} />
                  </ProviderUserTypeInfo.Provider>
                )}
              </Tabs.TabPane>
            </Tabs>
          </div>
        </Tabs.TabPane>
      </Tabs>

    </div>
  );
});

const ParticipantData = connect((state) => {
  if (!state.userInfo.userMap || !state.userInfo.userMap.erp) return {};
  return {
    erp: state.userInfo.userMap.erp,
  };
},null,null,{ forwardRef: true })(_ParticipantData);

export default ParticipantData;

